import { ConnectProto } from "@racoon/api";
import { useGetJobByIdQuery } from "~/shared/api/jobs/job.grpc";

type JobRef = Partial<Pick<ConnectProto.Job, "id" | "serviceReceiverId" | "serviceProviderId">>;

/**
 * The job as the backend has it now. A list's copy can be out of date, or partial: a route's job
 * list comes without the author.
 */
export const useFreshJob = (job?: JobRef | null) =>
  useGetJobByIdQuery(
    {
      id: job?.id ?? BigInt(0),
      serviceReceiverId: job?.serviceReceiverId ?? BigInt(0),
      serviceProviderId: job?.serviceProviderId ?? BigInt(0),
    },
    {
      refetchOnMountOrArgChange: true,
      skip: !job?.id || !job.serviceReceiverId || !job.serviceProviderId,
    },
  ).data;
